import React from 'react';
import { useNotification } from '../../../../Context/Notifications';

const NotificationPage = () => {
  const { seenNotifications, unseenNotifications } = useNotification();

  return (
    <div>
      <h1>Notifications</h1>
      <h2>Unseen</h2>
      {unseenNotifications.map((notif) => (
        <div key={notif.id}>
          <div className="notification-tile">
            <div className="notification-header">{notif.type}</div>
            <div>{notif.message}</div>
          </div>
        </div>
      ))}
      <h2>Seen</h2>
      {seenNotifications.map((notif) => (
        <div key={notif.id}>
          <div className="notification-tile">
            <div className="notification-header">{notif.type}</div>
            <div>{notif.message}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationPage;
